module.exports = __webpack_public_path__ + "static/media/undraw_destanation1_h3vq.74c033d2.svg";